import React, { useContext, useEffect, useState } from "react";
import estonianFlag from "../../product/images/languages/dymek_estonia.png";
import russianFlag from "../../product/images/languages/dymek_rosja.png";


import {
  generatePath,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import Store from "../../Store";
import Dropdown from "react-dropdown";
import { LanguageContext } from "../contexts/LanguageContext";
import "./navbarStyles.css";

export const LanguageChanger = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { lang, setLang } = useContext(LanguageContext);

  const options = [
    {
      value: "et",
      label: (
        <div className="Dropdown-items navAnimation">
          <img width={35} src={estonianFlag} alt="Eesti"></img>
          <p style={{ fontSize: "16px" }} className="dontshow">
            Eesti
          </p>{" "}
        </div>
      ),
    },
    {
      value: "ru",
      label: (
        <div className="Dropdown-items navAnimation">
          <img width={35} src={russianFlag} alt="Русский"></img>
          <p style={{ fontSize: "16px" }} className="dontshow">
            Русский
          </p>{" "}
        </div>
      ),
    },
  ];

  const handleSelect = ({ value }) => {
    const newLang = value;
    setLang(newLang);
    Store.setUserLanguage(newLang);
    Store.setUserPlatformLanguage(newLang);
    const pathParts = pathname.split("/");
    pathParts[1] = newLang;
    navigate(pathParts.join("/"));
  };

  return (
    <div>
      <Dropdown
        options={options}
        onChange={handleSelect}
        value={lang}
        placeholder="Select an option"
        controlClassName={"mySuperClass"}
      />
    </div>
  );
};
